/* Shared admin API helper. Reads JWT from localStorage and attaches to every request.
   On 401 calls the onUnauthorized callback (typically: clear token + force re-login). */
const API = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "magic_admin_jwt";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function adminApi(path, { method = "GET", body, token } = {}) {
 const headers = { "Content-Type": "application/json" };
 const t = token || getToken();
 if (t) headers.Authorization = `Bearer ${t}`;
 const res = await fetch(`${API}/api${path}`, {
  method, headers, body: body ? JSON.stringify(body) : undefined,
 });
 let data = null;
 try { data = await res.json(); } catch { /* no body */ }
 if (!res.ok) {
  const msg = (data && (data.detail || data.message)) || `Request failed (${res.status})`;
  const err = new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  err.status = res.status;
  err.data = data;
  throw err;
 }
 return data;
}

/** Downloads a PDF from an admin endpoint with JWT auth.
 *  Triggers a browser save-as with the server-supplied filename. */
export async function adminDownloadPdf(path, filename) {
 const t = getToken();
 const headers = t ? { Authorization: `Bearer ${t}` } : {};
 const res = await fetch(`${API}/api${path}`, { method: "GET", headers });
 if (!res.ok) {
  let msg = `Export failed (${res.status})`;
  try { const j = await res.json(); if (j && (j.detail || j.message)) msg = j.detail || j.message; } catch { /* ignore */ }
  const err = new Error(msg);
  err.status = res.status;
  throw err;
 }
 // Prefer server-supplied filename from Content-Disposition
 const cd = res.headers.get("content-disposition") || "";
 const match = cd.match(/filename="?([^"]+)"?/i);
 const outName = filename || (match && match[1]) || "magic-cruises-export.pdf";
 const blob = await res.blob();
 const url = URL.createObjectURL(blob);
 const a = document.createElement("a");
 a.href = url;
 a.download = outName;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 setTimeout(() => URL.revokeObjectURL(url), 1500);
}
